import {
  KbArticle,
  KbArticleInput,
  KbArticleSummary
} from 'types/KbArticleTypes';
import useHttp from '../helpers/HttpMethods';

class KbArticlesService {
  static async find(kbArticleId: number): Promise<KbArticle> {
    return await useHttp().get(`/kb-articles/${kbArticleId}`);
  }

  static async search(searchTerm: string): Promise<KbArticleSummary[]> {
    return await useHttp().get(
      `/kb-articles?searchTerm=${encodeURIComponent(searchTerm)}`
    );
  }

  static async create(body: KbArticleInput): Promise<KbArticle> {
    return await useHttp().post(body, '/kb-articles');
  }

  static async update(
    kbArticleId: number,
    body: KbArticleInput
  ): Promise<KbArticle> {
    return await useHttp().put(body, `/kb-articles/${kbArticleId}`);
  }

  static async createAndPublish(body: KbArticleInput): Promise<KbArticle> {
    return await useHttp().post(body, '/kb-articles/create-and-publish');
  }

  static async publish(kbArticleId: number): Promise<Response> {
    return await useHttp().post({}, `/kb-articles/${kbArticleId}/publish`);
  }

  static async unpublish(kbArticleId: number): Promise<Response> {
    return await useHttp().post({}, `/kb-articles/${kbArticleId}/unpublish`);
  }

  static async delete(kbArticleId: number): Promise<Response> {
    return await useHttp().del(`/kb-articles/${kbArticleId}`);
  }

  static async moveArticlesToFolder(payload: {
    kbArticleIds: number[];
    targetKbFolder: { id: number };
  }): Promise<Response> {
    return await useHttp().post(payload, '/kb-articles/batch-move');
  }
}

export default KbArticlesService;
